// DLC Client Config
// import { isProd } from "../env";
import template from "./_template";

const pge_config = {
    name: "pge",
    disabled_features: {
        ...template.disabled_features,
    },
    enabled_features: {
        ...template.enabled_features,
        dataset_dip: true, // Whether to ENABLE client to "dip" datasets to find mobile phone numbers
        campaign_templates: true, // Whether to ENABLE the templates feature for the client 
        wav_upload: true,
        suppress_optouts: true,
        optout_upload: true
    },
    sms: {
        short_codes: [
            { label: "97633-REST", value: "97633" },
            { label: "95243-REST", value: "95243" },
            { label: "32492-REST", value: "32492" },
        ],
    },
    voice: {
        premium_options: ["spanish"], // "all" || "premium" | "french" | "german" | "spanish"
        caller_id_options: [
            { label: "Select a phone number", isDisabled: true },
            { label: "PGE: (800) 743-5002", value: "8007435002" } //1-800-743-5002
        ],
    },
};

export default pge_config;
